module.exports = __webpack_public_path__ + "static/media/cardBg.bdb410f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_170/img/cardBg.png
// module id = 451
// module chunks = 0